import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import styled from "styled-components";

import {
  Card,
  Container,
  GRID_UNIT,
  Layout,
  LottieAnimation,
  Margin,
  Markdown,
  Text
} from "mf-ui-components";

import animationData from "./lottie-service-unavailable.json";

const WrapperImage = styled.div`
  display: inline-block;
  max-width: 610px;
`;

const ServiceUnavailableComponent = ({ intl }) => (
  <>
    <Container>
      <Layout width="10" mode="column" paddingTop={GRID_UNIT * 5}>
        <Card padding={GRID_UNIT * 4} style={{ textAlign: "center" }}>
          <WrapperImage>
            <LottieAnimation data={animationData} loop />
          </WrapperImage>
          <Margin top={GRID_UNIT * 5} bottom={GRID_UNIT}>
            <Text el="h5" styleName="title5">
              <FormattedMessage id="page.serviceUnavailable.title" />
            </Text>
          </Margin>
          <Markdown
            markdown={intl.formatMessage({
              id: `page.serviceUnavailable.markdown`
            })}
          />
        </Card>
      </Layout>
    </Container>
  </>
);

export const ServiceUnavailable = injectIntl(ServiceUnavailableComponent);
